<div class="modal-content border-0 rounded-4 shadow-lg">
  <div class="modal-header border-bottom-0 pb-0">
    <h5 class="modal-title fw-bold text-dark" style="font-size: 15px;">
      <fa-icon [icon]="faInfoCircle" class="me-2 text-primary"></fa-icon>
      {{ title }}
    </h5>
  </div>
  <div class="modal-body pt-2">
    <div class="reason-log-box">
      @for (line of reasonLines; track line) {
        <div class="reason-log-line">{{ line }}</div>
      }
    </div>
  </div>
  <div class="modal-footer border-top-0 pt-0">
    <button type="button" class="btn btn-sm app-btn-primary" (click)="activeModal.close()">Close</button>
  </div>
</div>
